<template>
  <div>
    <van-popup
      v-if="show"
      v-model="show"
      position="bottom"
      :style="{ height: '80%' }"
    >
      <div id="areaSearchBox">
        <div class="search">
          <div class="title">城市选择</div>
          <van-search
            v-model="searchValue"
            placeholder="请输入城市名"
            shape="round"
            @input="onInput"
          >
          </van-search>
        </div>
        <div class="hotCity">
          <div>热门城市</div>
          <div>
            <span
              v-for="(item, index) in hotCity"
              :key="index"
              @click="onSearch(item)"
              >{{ item.name }}</span
            >
          </div>
        </div>
        <div class="index-bar">
          <van-index-bar
            v-if="cityDataForSearchShow.length === 0 && !searchValue"
            :index-list="indexList"
            :sticky="false"
          >
            <div v-for="(item, index) in cityData" :key="index">
              <van-index-anchor :index="item.indexNum" />
              <van-cell
                @click="onSearch(items)"
                v-for="(items, indexs) in item.cityData"
                :key="indexs"
                :title="items.name"
              />
            </div>
          </van-index-bar>
          <van-index-bar
            v-if="cityDataForSearchShow.length > 0"
            :index-list="indexListForSearchShow"
            :sticky="false"
          >
            <div v-for="(item, index) in cityDataForSearchShow" :key="index">
              <van-index-anchor :index="item.indexNum" />
              <van-cell
                @click="onSearch(items)"
                v-for="(items, indexs) in item.cityData"
                :key="indexs"
                :title="items.name"
              />
            </div>
          </van-index-bar>
          <van-empty
            v-if="cityDataForSearchShow.length === 0 && searchValue"
            description="无符合城市"
          />
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { areaList } from "@vant/area-data";
import Vue from "vue";
import pinyin from "pinyin";
import { Popup, Search, IndexBar, IndexAnchor, Cell, Empty } from "vant";
Vue.use(Search);
Vue.use(IndexBar);
Vue.use(IndexAnchor);
Vue.use(Popup);
Vue.use(Empty);
Vue.use(Cell);
export default {
  data() {
    return {
      show: false,
      areaList,
      searchValue: "",
      hotCity: [
        { code: "999999", name: "全国" },
        { code: "110100", name: "北京市" },
        { code: "310100", name: "上海市" },
        { code: "440100", name: "广州市" },
        { code: "440300", name: "深圳市" },
        { code: "420100", name: "武汉市" },
        { code: "510100", name: "成都市" },
      ],
      cityData: [],

      indexList: [],
      cityDataForSearchShow: [],
      indexListForSearchShow: [],
    };
  },
  mounted() {
    // 遍历地区数据
    this.formatAreaData();
  },
  methods: {
    onSearch(row) {
      if (row.name == "全国") {
        delete this.$parent.params.cityCode;
      } else {
        this.$parent.params.cityCode = row.code;
      }
      this.$parent.areaTxt = row.name;
      // 设置产品标签为全部
      this.$parent.productTypeValue = "";
      this.$parent.productType2Value = "";
      // 清空产品类型参数
      this.$parent.params.type = "";
      this.$parent.params.secondType = "";
      // 关闭热门产品标签
      this.$parent.params.hotFlag = false;

      // 获取产品类型标签
      this.$parent.getProductType();
      // 获取产品类型2的标签
      this.$parent.getProductType2();

      this.show = false;
    },
    onInput(e) {
      this.cityDataForSearchShow = [];
      this.indexListForSearchShow = [];
      if (e) {
        this.scrollToDiv("areaSearchBox");
        this.cityData.forEach((item) => {
          let newObj = {
            indexNum: item.indexNum,
            cityData: [],
          };
          item.cityData.forEach((items) => {
            if (items.name.includes(e)) {
              newObj.cityData.push({
                name: items.name,
                code: items.code,
              });
            }
          });
          if (newObj.cityData.length > 0) {
            this.cityDataForSearchShow.push(newObj);
            this.indexListForSearchShow.push(newObj.indexNum);
          }
        });
      }
    },
    formatAreaData() {
      // 按照首字母构建数组对象
      Object.keys(areaList.city_list).forEach((key) => {
        let s = pinyin(areaList.city_list[key], {
          style: pinyin.STYLE_NORMAL,
        });
        // 获得当前城市名称的拼音首字母
        let S = s[0][0].slice(0, 1).toUpperCase();
        let o = this.cityData.find((item) => {
          return item.indexNum === S;
        });
        // 按首字母分配城市数据
        if (!o) {
          this.cityData.push({
            indexNum: S,
            cityData: [
              {
                name: areaList.city_list[key],
                code: key,
              },
            ],
          });
        } else {
          o.cityData.push({
            name: areaList.city_list[key],
            code: key,
          });
        }
        // 分配索引列表
        if (this.indexList.indexOf(S) === -1) {
          this.indexList.push(S);
        }
        // 索引列表按字母排序
        this.indexList.sort((a, b) => {
          if (a < b) {
            return -1;
          }
          if (a > b) {
            return 1;
          }
          return 0;
        });
      });
      // 成熟数据按照字母排序
      this.cityData.sort((a, b) => {
        let a1 = a.indexNum;
        let a2 = b.indexNum;
        if (a1 < a2) {
          return -1;
        }
        if (a1 > a2) {
          return 1;
        }
        return 0;
      });
    },
    scrollToDiv(divId) {
      var div = document.getElementById(divId);
      div.scrollIntoView({ behavior: "smooth", block: "start" });
    },
  },
};
</script>

<style scoped>
.search {
  padding-top: 16px;
  position: sticky;
  overflow: visible;
  top: 0;
  left: 0;
  background-color: white;
  z-index: 99;
}
.title {
  text-align: center;
  font-weight: 600;
  font-size: 20px;
}
.search .van-search {
  padding: 5vw 3vw 3vw 3vw;
}
.search .van-search__action {
  padding: 0 0 0 4vw;
}
.search .van-cell {
  line-height: 26px;
}
.hotCity {
  padding: 0 8vw 3vw 3vw;
}
.hotCity div:nth-of-type(1) {
  font-weight: 600;
}
.hotCity div:nth-of-type(2) {
  padding-top: 3vw;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 3vw;
}
.hotCity div:nth-of-type(2) span {
  display: inline-block;
  padding: 2vw 0;
  text-align: center;
  background-color: #f8f8f8;
  border-radius: 2px;
}
.index-bar {
  padding: 0 8vw 3vw 3vw;
}
.index-bar /deep/ .van-index-bar__sidebar {
  top: 62%;
  gap: 1vw;
}
.index-bar /deep/ .van-index-anchor {
  /* padding: 0 12px; */
  background-color: #f8f8f8;
}
.index-bar /deep/ .van-cell::after {
  border: none;
}

.index-bar /deep/ .van-index-bar__sidebar .van-index-bar__index--active {
  /* color: #2841c1; */
}
.index-bar /deep/ .van-index-bar__sidebar .van-index-bar__index {
  font-size: 12px;
}
.van-empty {
  padding-left: 5vw;
}
</style>


// WEBPACK FOOTER //
// src/view/productList/module/areaList.vue